var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.382 5.968C7.97575 4.69107 9.95781 3.99674 12 4C14.125 4 16.078 4.736 17.618 5.968L19.071 4.515L20.485 5.929L19.032 7.382C20.0897 8.70615 20.7521 10.302 20.9428 11.986C21.1336 13.6699 20.845 15.3735 20.1103 16.9007C19.3756 18.4279 18.2246 19.7167 16.7898 20.6186C15.355 21.5205 13.6947 21.999 12 21.999C10.3053 21.999 8.64498 21.5205 7.2102 20.6186C5.77541 19.7167 4.62443 18.4279 3.88973 16.9007C3.15502 15.3735 2.86644 13.6699 3.0572 11.986C3.24796 10.302 3.9103 8.70615 4.96801 7.382L3.51501 5.93L4.92901 4.516L6.382 5.969V5.968ZM13 12V7.495L8.00001 14H11V18.5L16 12H13ZM8.00001 1H16V3H8.00001V1Z",
    fill: "currentColor"
  })));
};
export default SvgStopwatch;